import { ConstructionConfig } from '../types/ConfigTypes';
export const getConstructionConfig = (): ConstructionConfig | undefined => {
  const globalConfig = window.ConfigUtility;

  if (!globalConfig) {
    console.warn('Unable to load construction config.');
    return;
  }

  return {
    agGridLicenseKey: globalConfig.agGridLicenseKey,
    apiBaseUri: globalConfig.apiBaseUri,
    consoleURL: globalConfig.consoleURL,
    constructionURL: globalConfig.constructionURL,
    ownersURL: globalConfig.ownersURL,
    vendorURL: globalConfig.vendorURL,
    env: globalConfig.env,
    fullstoryOrgId: globalConfig.fullstoryOrgId,
    froalaLicenseKey: globalConfig.froalaLicenseKey,
    launchDarklyClientId: globalConfig.constructionLaunchDarklyClientId,
    launchDarklyProxyURL: globalConfig.launchDarklyProxyURL,
    lendingV2LaunchDarklyClientId: globalConfig.lendingV2LaunchDarklyClientId,
    loginURL: globalConfig.loginURL,
    logoutURL: globalConfig.logoutURL,
    monitoring: {
      applicationId: globalConfig.constructionDataDogApplicationId,
      clientToken: globalConfig.constructionDataDogClientToken,
    },
    mapBoxAccessToken: globalConfig.mapBoxAccessToken,
    pendoApiKey: globalConfig.constructionPendoApiKey,
    runMode: globalConfig.constructionRunMode,
    salesforceApiEndpoint: globalConfig.constructionSalesforceApiEndpoint,
    salesforceDeploymentId: globalConfig.constructionSalesforceDeploymentId,
    salesforceOrganizationId: globalConfig.constructionSalesforceOrganizationId,
    snowplowURL: globalConfig.snowplowURL,
    standalone: globalConfig.constructionStandalone,
    tokenLife: 15,
    useDevTools: globalConfig.useDevTools,
    cognito: {
      isEnabled: globalConfig.cognito.isEnabled,
      isMocked: false,
      userPoolId: globalConfig.cognito.userPoolId,
      userPoolWebClientId: globalConfig.cognito.constructionUserPoolWebClientId,
      region: globalConfig.cognito.region,
    },
    cookies: {
      expires: '',
      path: globalConfig.cookies.path,
      domain: globalConfig.cookies.domain,
      secure: true,
    },
    adminPapi: {
      uri: globalConfig.adminPapi.uri,
    },
    bapi: {
      uri: globalConfig.bapi.uri,
    },
    builtWorkatoApi: {
      uri: globalConfig.builtWorkatoApi.uri,
    },
    capi: {
      uri: globalConfig.capi.uri,
    },
    cdsPapi: {
      uri: globalConfig.cdsPapi.uri,
    },
    frePapi: {
      uri: globalConfig.frePapi.uri,
    },
    imPapi: {
      uri: globalConfig.imPapi.uri,
    },
    papi: {
      uri: globalConfig.constructionPapi.uri,
    },
    paymentsPapi: {
      uri: globalConfig.paymentsPapi.uri,
    },
    pmPapi: {
      uri: globalConfig.pmPapi.uri,
    },
    ppPapi: {
      uri: globalConfig.ppPapi.uri,
    },
    tmPapi: {
      uri: globalConfig.tmPapi.uri,
    },
    tpmPapi: {
      uri: globalConfig.tpmPapi.uri,
    },
    lwioFileToolboxUrl: globalConfig.lwioFileToolboxUrl,
    fileStackApiKey: globalConfig.fileStackApiKey,
    sardineClientId: globalConfig.sardineClientId,
  };
};
